@if (open) {
<div
  #overlay
  class="bk-modal"
  (pointerdown)="onPointerDown($event)"
  (click)="onBackdropClick($event)"
>
  <div
    #dialog
    [class]="
      'modalContent bk-modal__content max-h-screen w-full overflow-x-hidden flex items-center justify-center' +
      ' ' +
      className
    "
    [attr.role]="dialogRole"
    aria-modal="true"
    [attr.aria-label]="label || null"
    [attr.aria-labelledby]="labelledBy"
    [attr.aria-describedby]="describedBy || null"
    cdkTrapFocus
    [cdkTrapFocusAutoCapture]="true"
  >
    <ng-content></ng-content>
  </div>
</div>
}
